const FunctionWords = [
	"if",
	"even",
	"not",
	"yes",
	"sure",
	"top",
	"bottom",
	"ok",
	"okay",
	"amen",
	"aka",
	"etc",
	"etcetera",
	"sorry",
	"please",
	"highly",
	"very",
	"really",
	"extremely",
	"absolutely",
	"completely",
	"totally",
	"utterly",
	"quite",
	"somewhat",
	"seriously",
	"fairly",
	"fully",
	"amazingly",
	"again",
	"definitely",
	"eternally",
	"expressively",
	"instead",
	"expressly",
	"immediately",
	"including",
	"instantly",
	"namely",
	"naturally",
	"next",
	"notably",
	"now",
	"nowadays",
	"ordinarily",
	"positively",
	"truly",
	"ultimately",
	"uniquely",
	"usually",
	"almost",
	"maybe",
	"probably",
	"granted",
	"initially",
	"too",
	"actually",
	"already",
	"e.g",
	"i.e",
	"often",
	"regularly",
	"simply",
	"optionally",
	"perhaps",
	"sometimes",
	"likely",
	"never",
	"ever",
	"else",
	"inasmuch",
	"provided",
	"currently",
	"incidentally",
	"elsewhere",
	"particular",
	"recently",
	"relatively",
	"f.i",
	"clearly",
	"apparently",
	"sooner",
	"just",
	"only",
	"and",
	"or",
	"and/or",
	"yet",
	"back",
	"within",
	"forward",
	"backward",
	"ahead",
	"in",
	"from",
	"with",
	"under",
	"throughout",
	"atop",
	"for",
	"on",
	"of",
	"to",
	"aboard",
	"about",
	"above",
	"abreast",
	"absent",
	"across",
	"adjacent",
	"after",
	"against",
	"along",
	"alongside",
	"amid",
	"mid",
	"among",
	"apropos",
	"apud",
	"around",
	"as",
	"astride",
	"at",
	"ontop",
	"afore",
	"tofore",
	"behind",
	"ahind",
	"below",
	"ablow",
	"beneath",
	"neath",
	"beside",
	"between",
	"atween",
	"beyond",
	"ayond",
	"by",
	"chez",
	"circa",
	"spite",
	"down",
	"except",
	"into",
	"less",
	"like",
	"minus",
	"near",
	"nearer",
	"nearest",
	"anear",
	"notwithstanding",
	"off",
	"onto",
	"opposite",
	"out",
	"outen",
	"over",
	"past",
	"per",
	"pre",
	"qua",
	"sans",
	"sauf",
	"sithence",
	"through",
	"thru",
	"truout",
	"toward",
	"underneath",
	"up",
	"upon",
	"upside",
	"versus",
	"via",
	"vis-à-vis",
	"without",
	"ago",
	"apart",
	"aside",
	"aslant",
	"away",
	"withal",
	"towards",
	"amidst",
	"amongst",
	"midst",
	"whilst",
	"doing",
	"daring",
	"having",
	"appearing",
	"becoming",
	"coming",
	"keeping",
	"remaining",
	"staying",
	"saying",
	"asking",
	"stating",
	"seeming",
	"letting",
	"making",
	"setting",
	"showing",
	"putting",
	"adding",
	"going",
	"using",
	"trying",
	"containing",
	"appear",
	"appears",
	"appeared",
	"become",
	"becomes",
	"became",
	"come",
	"comes",
	"came",
	"keep",
	"keeps",
	"kept",
	"remain",
	"remains",
	"remained",
	"stay",
	"stays",
	"stayed",
	"turn",
	"turns",
	"turned",
	"can",
	"cannot",
	"can't",
	"could",
	"couldn't",
	"could've",
	"dare",
	"dares",
	"dared",
	"do",
	"don't",
	"does",
	"doesn't",
	"did",
	"didn't",
	"done",
	"have",
	"haven't",
	"had",
	"hadn't",
	"has",
	"hasn't",
	"i've",
	"you've",
	"we've",
	"they've",
	"i'd",
	"you'd",
	"he'd",
	"she'd",
	"it'd",
	"we'd",
	"they'd",
	"would",
	"wouldn't",
	"would've",
	"may",
	"might",
	"must",
	"need",
	"needn't",
	"needs",
	"ought",
	"shall",
	"shalln't",
	"shan't",
	"should",
	"shouldn't",
	"will",
	"won't",
	"i'll",
	"you'll",
	"he'll",
	"she'll",
	"it'll",
	"we'll",
	"they'll",
	"there's",
	"there're",
	"there'll",
	"here's",
	"here're",
	"there'll",
	"always",
	"once",
	"twice",
	"thrice",
	"there",
	"here",
	"whither",
	"thither",
	"hither",
	"whence",
	"thence",
	"therefor",
	"therein",
	"hereby",
	"hereto",
	"wherein",
	"therewith",
	"herewith",
	"wherewith",
	"thereby",
	"where",
	"how",
	"why",
	"whether",
	"wherever",
	"whyever",
	"wheresoever",
	"whensoever",
	"howsoever",
	"whysoever",
	"whatsoever",
	"whereso",
	"whomso",
	"whenso",
	"howso",
	"whyso",
	"whoso",
	"whatso",
	"who",
	"whom",
	"which",
	"what",
	"whose",
	"one's",
	"nobody's",
	"everyone's",
	"everybody's",
	"someone's",
	"somebody's",
	"anyone's",
	"anybody's",
	"nothing's",
	"everything's",
	"something's",
	"anything's",
	"whoever's",
	"others'",
	"other's",
	"another's",
	"neither's",
	"either's",
	"none",
	"nobody",
	"everyone",
	"everybody",
	"someone",
	"somebody",
	"anyone",
	"anybody",
	"nothing",
	"everything",
	"something",
	"anything",
	"each",
	"other",
	"whatever",
	"whichever",
	"whoever",
	"whomever",
	"whomsoever",
	"whosoever",
	"others",
	"neither",
	"both",
	"either",
	"any",
	"such",
	"myself",
	"yourself",
	"himself",
	"herself",
	"itself",
	"oneself",
	"ourselves",
	"yourselves",
	"themselves",
	"all",
	"some",
	"many",
	"lot",
	"lots",
	"ton",
	"tons",
	"bit",
	"no",
	"every",
	"enough",
	"little",
	"much",
	"more",
	"most",
	"plenty",
	"several",
	"few",
	"fewer",
	"kind",
	"kinds",
	"my",
	"your",
	"his",
	"her",
	"its",
	"their",
	"our",
	"mine",
	"yours",
	"hers",
	"theirs",
	"ours",
	"this",
	"that",
	"these",
	"those",
	"me",
	"him",
	"us",
	"them",
	"i",
	"you",
	"he",
	"she",
	"it",
	"we",
	"they",
	"first",
	"second",
	"third",
	"fourth",
	"fifth",
	"sixth",
	"seventh",
	"eighth",
	"ninth",
	"tenth",
	"the",
	"an",
	"a",
];

export default FunctionWords;
